//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.07.2015.
 */

(function () {
    'use strict';

    angular
        .module('container.core')
        .service('domainService', domainService);
        //.service('apiInterceptor', apiInterceptor)
        //.config(configureApiInterceptor);

    function domainService($rootScope) {

        this.DOMAINS = Object.freeze({
            deviceManagement: 'Device Management',
            home: 'Home',
            eventManagement: 'Event Management',
            ruleManagement: 'Rule Management',
            administration:  'Administration'
        });
    }

    function apiInterceptor(API_URL) {

        this.request = function (config) {

            config.url = API_URL + config.url;
            return config;
        }
    }

    function configureApiInterceptor($httpProvider) {
        $httpProvider.interceptors.push('apiInterceptor');
    }

}());



